/* eslint-disable array-bracket-spacing */

/**
 *
 */
export default class RestApi {
  eds = {
    check: (uuid) => $app.coolApi.get(['documents/check*', uuid])
  }

  document = {
    getDocumentDataDto: (id) => $app.coolApi.get(['document*/data', id]),
    postValidateFile: (file) => $app.coolApi.post(['document/templates/validate']).data(file),
    postCreateTemplate: (data) => $app.coolApi.post(['document/templates/save']).data(data),
    getDocuments: () => $app.coolApi.get(['documents/get-all']),
    getTemplates: (companyId) => $app.coolApi.get(['document/templates*/get-all', companyId]),
    getTemplate: (id) => $app.coolApi.get(['document/templates*', id]),
    getTemplateAllTypes: () => $app.coolApi.get(['document-types/get-all']),
    downloadTemplateExcelFile: (templateId) =>
      $app.coolApi.get(['document-files*/get-template', templateId]),
    downloadTemplateDocFile: (templateId) =>
      $app.coolApi.get(['document/templates/download*', templateId]),
    // postCreateDocument: (id, file) => $app.coolApi.post(['create-document*', id]).data(file),
    postCreateDocument: (id, file) =>
      $app.coolApi.post(['document-requests*/create', id]).data(file),
    getDocumentRequest: (id) => $app.coolApi.get(['document-requests/get*', id]),
    getDocumentRequestStatus: (uuid) => $app.coolApi.get(['document-requests/status*', uuid]),
    getDocumentRequests: (id) => $app.coolApi.get(['document-requests/get-all', id]),
    patchDocumentRequest: (uuid, data) => $app.coolApi.put(['document-requests*', uuid]).data(data),
    postDocumentRequestFile: (id, file) =>
      $app.coolApi.post(['document-files*/users-data/upload', id]).data(file),
    postTemplateFile: (id, file) =>
      $app.coolApi.post(['document-files*/users-data/upload', id]).data(file),
    postTemplateForm: (id, data) => $app.coolApi.post(['document-requests/create*', id]).data(data),
    postTemplateEdit: (id, data) => $app.coolApi.post(['document/templates*', id]).data(data),
    postTemplateEnable: (id, isEnabled) => $app.coolApi.post([`document/templates*/enable?enable=${isEnabled}`, id]),
    postDocumentSignType: (data) => $app.coolApi.post(['document/sign']).data(data),
    getDocumentBase64: (id) => $app.coolApi.get(['documents*/get-pdf', id]),
    getDocumentBase64Multi: () => $app.coolApi.get(['documents/multi/get-pdf']),
    postSignDocuments: (data) => $app.coolApi.post(['document/sign/complete/multi']).data(data),
    postSignDocument: (data) => $app.coolApi.post(['document/sign/complete']).data(data),
    getDocumentsStatistic: () => $app.coolApi.get(['documents/statistic']),
    getSignatures: (id) => $app.coolApi.get(['documents*/signatures', id]),
    getStaticTags: () => $app.coolApi.get(['tags/static']),
    getRequestPdf: (reqId) => $app.coolApi.get(['documents*/get-pdf', reqId]),
    getQr: (reqId) => $app.coolApi.get(['documents*/get-qr', reqId]),
    getCms: (reqId) => $app.coolApi.get(['documents*/cms', reqId]),
  }

  report = {
    getReportTemplates: () => $app.coolApi.get(['report-service/admin/template']),
    getReportTemplate: (id) => $app.coolApi.get(['report-service/admin/template', id]),
    putReportTemplate: (data) => $app.coolApi.put(['report-service/admin/template']).data(data),
    postCreateReportTemplate: (data) => $app.coolApi.post(['report-service/admin/template']).data(data),
    postDownloadReport: (data) => $app.coolApi.post(['report-service/admin/report']).data(data),
    getFieldsForReport: () => $app.coolApi.get(['report-service/field/admin/column']),
    getAvailableFormatsToDownload: () => $app.coolApi.get(['report-service/company/report/format']),
    deleteReportTemplate: (id) => $app.coolApi.delete(['report-service/admin/template', id]),
  }

  statistics = {
    getDocuments: (query) => $app.coolApi.get([ 'documents/statistics' ]).query(query),
    getTemplates: () => $app.coolApi.get([ 'document/templates/active/slim' ])
  }
}
